export default __webpack_public_path__ + "static/media/picload.8c0fce6d.JPG";